const state = () => ({
    zfPropertyName:'',
    floorName: '',
    levelName: ''
})
const getters = {
    zfPropertyName: (state) => state.zfPropertyName,
    floorName: (state) => state.floorName,
    levelName: (state) => state.levelName,
}
const mutations = {

    setZfPropertyName(state, zfPropertyName) {
        state.zfPropertyName = zfPropertyName
    },
    setFloorName(state, floorName) {
        state.floorName = floorName
    },
    setLevelName(state, levelName) {
        state.levelName = levelName
    },

}
const actions = {
    setZfPropertyName({ commit }, zfPropertyName) {
        commit('setZfPropertyName', zfPropertyName)
    },
    setFloorName({ commit }, floorName) {
        commit('setFloorName', floorName)
    },
    setLevelName({ commit }, levelName) {
        commit('setLevelName', levelName)
    },

}
export default {
    state,
    getters,
    mutations,
    actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/roomAvailability.js